import clsx from "clsx";
import Styles from "./index.module.scss";
import { LoginInput } from "../../../Components/Atoms/LoginInput";
import { Controller } from "react-hook-form";
import { useAdminVerifyPage } from "../../../Hooks/useAdminVerifyPage";

function VerifyPage() {
  const { control, handleSubmit, loading } = useAdminVerifyPage();
  return (
    <div className={clsx(Styles.main)}>
      <div className={clsx(Styles.formBox)}>
        <div className={clsx(Styles.formValue)}>
          <h2>MÃ XÁC NHẬN</h2>
          <form onSubmit={handleSubmit} className={clsx(Styles.form)}>
            <Controller
              name="code"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <LoginInput
                  label="Mã Xác Nhận"
                  value={field.value}
                  onChange={field.onChange}
                  error={error}
                />
              )}
            />

            <button className={clsx(Styles.span)} type="submit">
              {loading ? "Đang xác minh . . ." : "Xác nhận"}
            </button>
          </form>
          <p className={clsx(Styles.notify)}>
            Mã xác nhận đã được gửi đến mail bạn
          </p>
        </div>
      </div>
    </div>
  );
}

export default VerifyPage;
